import styled from 'styled-components';

import { SkeletonElement } from '@notino/react-styleguide-v20';

export const StyledPriceContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1rem;
  justify-content: space-between;
`;

export const StyledSkeleton = styled(SkeletonElement)`
  height: 1rem;
  margin-bottom: 0.5rem;
`;
